






import { Vue, Prop, Component } from "vue-property-decorator";

@Component
export default class Button extends Vue {
    @Prop({ type: Boolean }) isDisabled!: boolean;
    @Prop({ type: Boolean }) isDay!: boolean;
    @Prop({ type: Boolean }) isDayWithTooltip!: boolean;
    @Prop({ type: Boolean }) isHour!: boolean;
    @Prop({ type: Boolean }) isHourArrow!: boolean;
    @Prop({ type: Boolean }) isMonth!: boolean;
    @Prop({ type: Boolean }) isYear!: boolean;
    @Prop({ type: Boolean }) isBottom!: boolean;

    private get btnClass(): { [key: string]: boolean } {
        return {
            "is-hour": this.isHour,
            "is-hour-arrow": this.isHourArrow,
            "is-day": this.isDay,
            "is-month": this.isMonth,
            "is-year": this.isYear,
            "is-main": this.isDay || this.isMonth || this.isYear,
            "is-bottom": this.isBottom,

            "effect-on-hover": !this.isDisabled,
            "effect-on-click": !this.isDisabled && !this.isDayWithTooltip,
            // "text-red-500 dark:text-secondary-dark-500": !this.isDisabled,

            "cursor-not-allowed day-out": this.isDisabled,
        };
    }

    private onClick() {
        if (!this.isDisabled) {
            this.$emit("click");
        }
    }
}
